import React from 'react';
import { Tabs } from 'antd';

const TabPane = React.memo(({ style, ...rest }) => (
  <Tabs.TabPane forceRender style={{ padding: '24px', ...style }} {...rest} />
));

export default TabPane;
